import { useContext } from 'react';

import { ScreenResponsiveLayoutContext } from 'components/ResponsiveLayout';

export const useScreenWidth = (): number => {
  const { screenWidth } = useContext(ScreenResponsiveLayoutContext);

  return screenWidth;
};
